<template>
<div>
  <div id="cpjsEdit" v-if="editFlag">
      <div id="cpjsView" class="pt15">
        <el-row class="mb5" style="border-bottom:1px solid #2452ff;line-height: 29px;">
          <el-col :span="24">
            <strong style="color: #2452ff;">企业介绍</strong>
          </el-col>
        </el-row>
        <el-form class="el-form demo-form-inline" ref="qyjsForm" :model="qyjsForm" label-position="right" label-width="150px" :rules="qyjsRules">
            <el-row class="tr mb5">
              <el-col :span="9">
                <el-form-item label="企业LOGO图标" style="text-align: left" class="is-required">
                  <el-upload class="avatar-uploader"
                  ref="uploadLogo"
                  :headers="myHeaders"
                  :action="qylogoUploadAction"
                  :data="upLoadLogoData"
                  :on-success="logoPicSuccess"
                  :before-upload="LogoChange"
                  :show-file-list="false"
                  accept=".jpg,.png">
                    <img v-if="qyjsForm.src!==''&& qyjsForm.src!==null" :src="qyjsForm.imageUrl" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    <div class="el-upload__tip" slot="tip">jpg/png文件，且小于5MB</div>
                  </el-upload>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="1">&nbsp;</el-col> -->
              <el-col :span="14" style="margin-left: -10%" id="qycpArea">
                <el-row>
                  <el-form-item prop="qyjj" style="text-align: left" label="企业简介">
                    <el-input type="textarea" :rows="2" maxlength="200" placeholder="企业简介" v-model="qyjsForm.qyjj" :onkeyup="checkWord(qyjsForm.qyjj,'qyjsLength','200')"></el-input>
                  </el-form-item>
                  <el-row style="margin-top: -15px;margin-bottom: 15px;">
                    <div class="el-upload__tip">还可输入
                      <span style="color: red" id="qyjsLength">{{200-qyjsForm.qyjj.length}}</span>个字</div>
                  </el-row>
                </el-row>
                <el-row>
                  <el-form-item prop="reserve1" style="text-align: left" label="企业英文简介">
                    <el-input type="textarea" :rows="2" maxlength="500" placeholder="企业英文简介" v-model="qyjsForm.reserve1" :onkeyup="checkWord(qyjsForm.reserve1,'qyywjsLength','500')"></el-input>
                  </el-form-item>
                  <el-row style="margin-top: -15px;margin-bottom: 15px;">
                    <div class="el-upload__tip">还可输入
                      <span v-if="qyjsForm.reserve1!=null" style="color: red" id="qyywjsLength">{{500-qyjsForm.reserve1.length}}</span>
                      <span v-else style="color: red" id="qyywjsLength">500</span>
                      个英文字符</div>
                  </el-row>
                </el-row>
              </el-col>
              <el-col :span="1">&nbsp;</el-col>
            </el-row>
       
            <el-row class="mb5" style="border-bottom:1px solid #2452ff;line-height: 29px;">
              <el-col :span="12">
                <strong style="color: #2452ff;">产品介绍（可添加2至15条产品信息）</strong>
              </el-col>
              <el-col :span="12" class="pb1">
                <el-button type="primary" icon="el-icon-plus" size="small" class="r" @click="addDomain">增加产品</el-button>
              </el-col>
            </el-row>
            <el-row class="mt15 mb20" style="overflow-x: hidden">
              <el-card class="card_style" id="cp_card" v-for="(domain, index) in qyjsForm.qycpjsVOList" :key="index" style="margin-right: -15px !important; ">
                <div slot="header" class="clearfix" >
                  <strong class="card_title_font">产品{{index+1}}</strong>
                  <el-button type="danger" icon="el-icon-minus" size="small" @click.prevent="removeDomain(domain)" class="r" style="margin: 4px 0px 0px 0px">删除产品</el-button>
                </div>
                <el-row class="tr">
                  <el-col :span="9">
                    <el-form-item label="产品图片" style="text-align: left" class="is-required">
                      <el-upload class="avatar-uploader"
                      ref="uploadCpPics"
                      :headers="myHeaders"
                      :action="cptpUploadAction"
                      :on-success="cpjsPicSuccess"
                      :before-upload="CpPicsChange"
                      :show-file-list="false"
                      :data="CpjsUpLoadData"
                      accept=".jpg,.png">
                        <img @click="getIndex(index,domain.src)" v-if="domain.src!=='' && domain.src!==null" :src="domain.imageUrl" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon" @click="getIndex(index)"></i>
                        <div class="el-upload__tip" slot="tip">jpg/png文件，且小于5MB</div>
                      </el-upload>
                    </el-form-item>
                  </el-col>
                  <el-col :span="14" style="margin-left: -10%">
                    <el-row>
                      <el-form-item label="产品所属分类" class="is-required" :prop="'qycpjsVOList.' + index + '.cplx'" :rules="qyjsRules.cplx">
                        <el-cascader :options="cpssfl_data" :props="defaultProps" size="small" v-model="domain.cplx" placeholder="产品所属分类" class="searchSelect" clearable show-all-levels></el-cascader>
                      </el-form-item>
                    </el-row>
                    <el-row>
                      <div class="el-upload__tip"></div>
                    </el-row>
                    <el-row id="cpjsArea">
                      <el-form-item label="产品简介" :prop="'qycpjsVOList.' + index + '.cpjj'" :rules="qyjsRules.cpjj">
                        <el-input type="textarea" maxlength="500" :rows="2" placeholder="产品简介" v-model="domain.cpjj" :onkeyup="checkWord(domain.cpjj,index+100,'500')"></el-input>
                      </el-form-item>
                    </el-row>
                    <el-row style="margin-top: -15px;margin-bottom: 15px;">
                      <div class="el-upload__tip">还可输入
                        <span style="color: red" :id="index+100">{{500-domain.cpjj.length}}</span>个字</div>
                    </el-row>
                    <el-row id="cpjsArea">
                      <el-form-item label="产品英文简介" :prop="'qycpjsVOList.' + index + '.cpjj_eng'" :rules="qyjsRules.cpjj_eng">
                        <!-- <el-input type="textarea" maxlength="400" :rows="2" placeholder="产品英文简介" v-model="domain.cpjj_eng" :onkeyup="checkWord(domain.cpjj_eng,index+200,'400')"></el-input> -->
                        <el-input type="textarea" :rows="2" placeholder="产品英文简介" v-model="domain.cpjj_eng" :onkeyup="checkEngWord(domain.cpjj_eng,index+200,'500')" ></el-input>
                      </el-form-item>
                    </el-row>
                    <el-row style="margin-top: -15px;margin-bottom: 15px;">
                      <div class="el-upload__tip">还可输入
                        <span v-if="domain.cpjj_eng!=null" style="color: red" :id="index+200"></span>
                        <span v-else style="color: red" :id="index+200">500</span>
                        个英文单词</div>
                    </el-row>
                  </el-col>
                </el-row>
              </el-card>
            </el-row>
            <el-row class="buttonSubmit">
              <el-col :span="24">
                <el-button v-if="qyjsData.validateFlag=='T'" type="info" icon="el-icon-close" size="small" class="btn_submit" @click="cancel()">取消</el-button>
                <el-button type="success" icon="el-icon-check" size="small" class="btn_submit"  @click="submitCpjs('qyjsForm')">保存</el-button>
              </el-col>
            </el-row>
        </el-form>
        
      </div>
  </div>

  <div class="main-container" element-loading-text="加载中" v-if="!editFlag">
    <div id="qycpjs" class="mb5">
       
        <el-row class="mb10">
          <el-col :span="1">&nbsp;</el-col>
          <el-col :span="10">
            <strong  class="vt">企业Logo：</strong>
            <img v-if="qyjsData.imageUrl!==''" :src="qyjsData.imageUrl" @click="imgPreview(qyjsData.imageUrl)" style="max-width:100%;max-height:140px;" class="poi">
            <div v-else style="width:100px;" class="iconfont icon-noPic"></div>
          </el-col>
          <el-col :span="11">
            <strong >企业简介：</strong>
            <span  v-text="qyjsData.qyjj||'无'"></span>
            <br>
            <strong >企业英文简介：</strong>
            <span v-text="qyjsData.reserve1||'无'"></span>
          </el-col>
          <el-col :span="2">
              <el-button type="primary" icon="el-icon-edit" size="small" class="btn_submit" @click="editClick()">编辑</el-button>
            </el-col>
        </el-row>
        <el-row class="mb10">
          <el-col :span="1">&nbsp;</el-col>
          <el-col :span="22">
            <el-row class="mb10">
              <strong>产品介绍：</strong>
            </el-row>
            <el-form id="cpjs" v-if="cpjsData.length>0" :inline="true" style="width: 100%;" class="demo-form-inline">
              <el-form-item v-for="(cpjs,index) in cpjsData" style="width: 49%;" :key="index">
                <el-card class="mb10 card_style" id="cpjsImg">
                  <el-row class="h100">
                    <el-col :span="5" class="h100 tc">
                      <img v-if="cpjs.imageUrl!==''" :src="cpjs.imageUrl" @click="imgPreview(cpjs.imageUrl)" class="poi">
                      <div v-else style="width:100px;" class="iconfont icon-noPic"></div>
                    </el-col>
                    <el-col :span="19" style="line-height: 24px;" class="pl15">
                      <strong>产品类型：</strong>
                      <span v-text="cpjs.cplxmc||'无'"></span>
                      <br>
                      <strong>产品简介：</strong>
                      <span v-text="cpjs.cpjj||'无'"></span>
                      <br>
                      <strong>产品英文简介：</strong>
                      <span v-text="cpjs.cpjj_eng||'无'"></span>
                    </el-col>
                  </el-row>
                </el-card>
              </el-form-item>
            </el-form>
            <span v-else>暂无产品信息</span>
          </el-col>
        </el-row>
    </div>

    <!--图片预览-->
      <el-dialog id="previewImgDialog" :visible.sync="showPicVisible" :close-on-click-modal="false" size="tiny">
        <img :src="previewImg" width="100%" class="mt15">
      </el-dialog>
  </div>

</div>
</template>

<script>
import secureImageMixin from '@/common/js/secureImageMixin'
export default {
  mixins: [secureImageMixin],
  props:{
    qyid: {
        type: String,
        required: true
    },
  },
  name: "cpjsEdit",
  data() {
    return {
      baseUrl: window.config.baseUrl,
      myHeaders: { XTOKEN: localStorage.getItem("XTOKEN") },
      //当前用户
      currentUser: this.CONSTANT.currentUser,
      cptpUploadAction: window.config.domain+'/qycpjs/upload',
      qylogoUploadAction: window.config.domain+'/qyjs/upload',
      //产品所属分类
      cpssfl_data: [],
      //产品index
      index: 0,
      //产品图片上传参数
      CpjsUpLoadData: {
        qyid: ""
      },
      //上传logo加参数
      upLoadLogoData: {
        uuid: "",
        qyid: ""
      },
      //公司logo
      imageUrl: "",
      //要删除的图片路径list
      delPicList: [],
      delPicSrc: "",
      //上传后未保存的图片list
      unsavedPicList: [],
      //上传图片Data
      fileList: [],
      //上传加参数
      upLoadData: {
        qyid: ""
      },
      //企业介绍表单
      qyjsForm: {
        qyid: "",
        //logo:'',
        qyjj: "",
        qycpjsVOList: [],
        src: "",
        imageUrl: "",
        reserve1: ""
      },
      qyjsRules: {
        qyjj: [
          { required: true, message: "请输入企业简介", trigger: "blur" },
          { min: 1, max: 200, message: "最多可输入200个字", trigger: "blur" }
        ],
        reserve1: [
        /*  {
            pattern: /^[\da-zA-Z \!\?\r\n\|\<\>\.\,\，\;\:\'\"\@\#\$\￥\=\+\_\—\%\^\&\*\(\)\（\）\[\]\{\}\\\/\~\`\-]*$/,
            message: "只能输入字母、数字和英文符号",
            trigger: "blur"
          },*/
          { validator: (rule, value, callback) => {
            if (value) {
              if (/[\u4E00-\u9FA5]/g.test(value)) {
                callback(new Error('请输入英文字符'));
              } else {
                callback();
              }
            }
            callback();
            }, trigger: 'blur' },
          { min: 1, max: 500, message: "最多可输入500个字符", trigger: "blur" }
        ],
        cpjj: [{ required: true, message: "请输入产品简介", trigger: "blur" }],
        /*
        reserve1: [
          {
            pattern: /^[\da-zA-Z \!\?\r\n\|\<\>\.\,\，\;\:\'\"\@\#\$\￥\=\+\_\—\%\^\&\*\(\)\（\）\[\]\{\}\\\/\~\`\-\。\·\…\！\、\“\”\‘\’\《\》\<\>\【\】\：\；\？]*$/,
            message: "只能输入字母、数字和英文符号",
            trigger: "blur"
          }
        ],*/
        cpjj_eng: [
          {validator: (rule, value, callback) => {
            if (value) {
              if (/[\u4E00-\u9FA5]/g.test(value)) {
                callback(new Error('请输入英文字符'));
              } else {
                callback();
              }
            }
            callback();
            }, trigger: 'blur' },
          { min: 1, max: 5000, message: "最多可输入5000个字符", trigger: "blur" }
        ],
        cplx: [
          {
            validator: (rule, value, callback) => {
              if (value.length == 0) {
                callback(new Error("请选择产品所属分类"));
              } else {
                callback();
              }
            },
            trigger: "change"
          }
        ]
      },
      // cpjsRules: {
      //   cplx: [
      //     { required: true, message: "请选择产品所属分类", trigger: "change" }
      //   ],
      //   cpjj: [
      //     { required: true, message: "请输入产品简介", trigger: "blur" },
      //     { min: 1, max: 500, message: "最多可输入500个字", trigger: "blur" }
      //   ],
      //   cpjj_eng: [
      //   /*  {
      //       pattern: /^[\da-zA-Z \!\?\|\<\>\.\,\，\;\:\'\"\@\#\$\￥\=\+\_\—\%\^\&\*\(\)\（\）\[\]\{\}\\\/\~\`\-]*$/,
      //       message: "只能输入字母、数字和英文符号",
      //       trigger: "blur"
      //     },*/
      //     { validator: (rule, value, callback) => {
      //       if (value) {
      //         if (/[\u4E00-\u9FA5]/g.test(value)) {
      //           callback(new Error('请输入英文字符'));
      //         } else {
      //           callback();
      //         }
      //       }
      //       callback();
      //       }, trigger: 'blur' },
      //     { min: 1, max: 5000, message: "最多可输入5000个字符", trigger: "blur" }
      //   ]
      // },
      //树结构配置
      defaultProps: {
        children: "children",
        label: "codeName",
        value: "codeValue"
      },
      cpjsStatus: 0,

      editFlag: false,
      //企业介绍
      qyjsData: {
        logoBase64: "",
        qyjj: ""
      },
      //产品介绍
      cpjsData: [],
      previewImg: "",
      showPicVisible: false,
    };
  },
  watch: {
    qyid(){
      if(this.qyid == 'newInsert'){
        this.editFlag = true;
        if (this.qyjsForm.qycpjsVOList.length == 0) {
              this.qyjsForm.qycpjsVOList.push({
                qyid: this.qyid,
                cplx: [],
                cpjj: "",
                cpjj_eng: "",
                src: "",
                imageUrl: "",
                key: Date.now()
              });
            }
      }else if(this.qyid != ''){
        this.findQyjsByQyid(this.qyid);
      }
    }
  },
  created: function() {
    
    this.getCpssfl(); //产品所属分类
    //this.findQyjsByQyid(this.qyid);
  },
  methods: {
    //根据代码集获取产品所属分类
    getCpssfl: function() {
      let vm = this;
      vm.$axios.get("/codelist/getZycpTree/CPLX").then(
        function(res) {
          vm.cpssfl_data = res.data.result;
        }.bind(vm),
        function(error) {
          console.log(error);
        }
      );
    },
    //通过企业id查找企业和产品介绍
    findQyjsByQyid: function(qyid) {
      let vm = this;
      vm.$emit("getLoading", true);
      var params = {
        qyid: qyid,
        deleteFlag: "N"
      };
      vm.$axios.post("/qyjs/list", params).then(
        function(res) {
          if (res.data.result.length > 0) {
            this.qyjsData = JSON.parse(JSON.stringify(res.data.result[0]));
            this.qyjsData.imageUrl =
              vm.baseUrl + "/upload/" + this.qyjsData.src;
            if(res.data.result[0].validateFlag == 'T'){
                vm.editFlag = false;
            }else{
                vm.editFlag = true;
            }

            vm.cpjsStatus = 1; //修改
            var resultForm = res.data.result[0];
            var params = {
              qyid: qyid,
              deleteFlag: "N"
            };
            vm.$axios.post("/qycpjs/list", params).then(
              function(res) {
                var result = res.data.result;
                var qycpjsList = [];
                for (var i in result) {
                  var cplxArray = [];
                  if(result[i].cplx){
                    cplxArray.push(result[i].cplx.substr(0, 1) + "000");
                    cplxArray.push(result[i].cplx.substr(0, 2) + "00");
                    cplxArray.push(result[i].cplx);
                  }
                  
                  qycpjsList.push({
                    uuid: result[i].uuid,
                    qyid: result[i].qyid,
                    cpjj: result[i].cpjj,
                    cpjj_eng: result[i].cpjj_eng,
                    cplx: cplxArray,
                    cplxmc: result[i].cplxmc,
                    src: result[i].src,
                    imageUrl: vm.baseUrl + "/upload/" + result[i].src
                  });
                }

                this.cpjsData = JSON.parse(JSON.stringify(qycpjsList));

                resultForm.qycpjsVOList = qycpjsList;
                vm.qyjsForm = resultForm;
                vm.qyjsForm.imageUrl = vm.baseUrl + "/upload/" + vm.qyjsForm.src;


                vm.$emit("getLoading", false);
              }.bind(vm),
              function(error) {
                vm.$emit("getLoading", false);
                console.log(error);
              }
            );
            vm.CpjsUpLoadData.qyid = vm.qyid;
            vm.upLoadLogoData.qyid = vm.qyid;
          } else {
            vm.editFlag = true;
            vm.cpjsStatus = 0; //新增
            vm.CpjsUpLoadData.qyid = vm.qyid;
            vm.upLoadLogoData.qyid = vm.qyid;
            if (vm.qyjsForm.qycpjsVOList.length == 0) {
              vm.qyjsForm.qycpjsVOList.push({
                qyid: vm.qyid,
                cplx: [],
                cpjj: "",
                cpjj_eng: "",
                src: "",
                imageUrl: "",
                key: Date.now()
              });
            }
            vm.$emit("getLoading", false);
          }
        }.bind(vm),
        function(error) {
          vm.$emit("getLoading", false);
          console.log(error);
        }
      );
    },
    //产品图片上传成功回调方法
    cpjsPicSuccess: function(res, file) {
      this.qyjsForm.qycpjsVOList[this.index].src = res.src;
      this.setLocalImage(this.qyjsForm.qycpjsVOList[this.index], 'imageUrl', file.raw);
    //  this.unsavedPicList.push(res.src);
    },
    logoPicSuccess: function(res, file) {
      this.qyjsForm.src = res.src;
      this.setLocalImage(this.qyjsForm, 'imageUrl', file.raw);
    //  this.unsavedPicList.push(res.src);
    },
    //企业logochange
    LogoChange: function(file, fileList) {
      var fileName = file.name.lastIndexOf("."); //取到文件名开始到最后一个点的长度
      var fileNameLength = file.name.length; //取到文件名长度
      var fileFormat = file.name.substring(fileName + 1, fileNameLength);
      const isPng = fileFormat.toLowerCase() == "png";
      const isJpg = fileFormat.toLowerCase() == "jpg";
      const isLt1M = file.size / 1024 / 1024 <= 5;
      if (!isPng && !isJpg) {
        this.$message.error("只能上传jpg、png格式的图片");
      } else if (!isLt1M) {
        this.$message.error("上传图片大小须小于5MB!");
      } else {
        this.delPicList.push(this.qyjsForm.src);
      }
      return isLt1M && (isPng||isJpg);
    },
    //产品图片change
    CpPicsChange: function(file, fileList) {
      var fileName = file.name.lastIndexOf("."); //取到文件名开始到最后一个点的长度
      var fileNameLength = file.name.length; //取到文件名长度
      var fileFormat = file.name.substring(fileName + 1, fileNameLength);
      const isPng = fileFormat.toLowerCase() == "png";
      const isJpg = fileFormat.toLowerCase() == "jpg";
      const isLt2M = file.size / 1024 / 1024 <= 5;
      if (!isPng && !isJpg) {
        this.$message.error("只能上传jpg、png格式的图片");
      } else if (!isLt2M) {
        this.$message.error("上传图片大小须小于5MB!");
      } else {
        this.delPicList.push(this.delPicSrc);
      }
      return isLt2M && (isPng||isJpg);
    },
    //获取点击上传的产品图片位于第几个card，用于赋src值
    getIndex: function(index, src) {
      this.index = index;
      if (src != null && src != undefined && src != "") {
        //this.delPicList.push(src);
        this.delPicSrc = src;
      }
    },
    //新增产品card
    addDomain: function() {
   
      //判断最后一个card产品信息是否填全
      var cp = this.qyjsForm.qycpjsVOList[
        this.qyjsForm.qycpjsVOList.length - 1
      ];
      if (cp.cplx == "" || cp.cpjj == "" || cp.src == "") {
        // this.$message({
        //   message: "请完整填写产品信息中的全部内容",
        //   type: "warning"
        // });
        this.$alert('请完整填写产品信息中的全部内容', '提示', {
          confirmButtonText: '确定',
          type: 'warning'
        });
        return false;
      } else {
        if (this.qyjsForm.qycpjsVOList.length < 15) {
          this.qyjsForm.qycpjsVOList.push({
            qyid: this.qyid,
            cplx: [],
            cpjj: "",
            cpjj_eng: "",
            src: "",
            imageUrl: "",
            key: Date.now()
          });
        } else {
          // this.$message({
          //   message: "最多可添加15条产品介绍",
          //   type: "warning"
          // });
          this.$alert('最多可添加15条产品介绍', '提示', {
            confirmButtonText: '确定',
            type: 'warning'
          });
        }
      }
    },
    //删除产品card
    removeDomain: function(item) {
      if (this.qyjsForm.qycpjsVOList.length > 2) {
        var index = this.qyjsForm.qycpjsVOList.indexOf(item);
        if (index !== -1) {
          if (
            this.qyjsForm.qycpjsVOList[index].src != "" &&
            this.qyjsForm.qycpjsVOList[index].src != null &&
            this.qyjsForm.qycpjsVOList[index].src != undefined
          ) {
            this.delPicList.push(this.qyjsForm.qycpjsVOList[index].src);
          }
          this.qyjsForm.qycpjsVOList.splice(index, 1);
        }
      } else {
        this.$alert('请最少填写两条产品介绍', '提示', {
          confirmButtonText: '确定',
          type: 'warning'
        });
      }
    },
    //产品介绍提交（下一步）
    submitCpjs: function(formName) {
      let vm = this;
      if (vm.qyid == 'newInsert') {
        vm.$alert("保存失败，请先填写企业基本信息后再填写其他信息", '提示', {
          confirmButtonText: '确定'
        });
      }else{
        vm.$refs[formName].validate(valid => {
          if (valid) {
            //判断最后一个card产品信息是否填全
            var cp = vm.qyjsForm.qycpjsVOList[vm.qyjsForm.qycpjsVOList.length - 1];
            if ( vm.qyjsForm.imageUrl == null || vm.qyjsForm.imageUrl == "") {
              //判断企业logo是否上传
              this.$alert('请上传企业logo', '提示', {
                confirmButtonText: '确定',
                type: 'warning'
              });
              console.log("error submit!!");
              return false;
            } else if (cp.cplx == "" || cp.cpjj == "" || cp.src == "") {
              this.$alert('请完整填写产品信息', '提示', {
                confirmButtonText: '确定',
                type: 'warning'
              });
              return false;
            } else if (vm.qyjsForm.qycpjsVOList.length < 2) {
              this.$alert('请最少填写两条产品介绍', '提示', {
                confirmButtonText: '确定',
                type: 'warning'
              });
                console.log("error submit!!");
                return false;
            
            }
            else {
              //信息填写完整
              var tempList = [];
              for (var i in vm.qyjsForm.qycpjsVOList) {
                var qycpjsVO = vm.qyjsForm.qycpjsVOList[i];
                //产品类型级联下拉处理
                if ( qycpjsVO.cplx.constructor == Array && qycpjsVO.cplx.length > 0) {
                  var length = qycpjsVO.cplx.length;
                  var cplx_temp = qycpjsVO.cplx[length - 1];
                }
                var obj_temp = {
                  uuid: qycpjsVO.uuid,
                  qyid: vm.qyid,
                  src: qycpjsVO.src,
                  cplx: cplx_temp,
                  cpjj: qycpjsVO.cpjj,
                  cpjj_eng: qycpjsVO.cpjj_eng
                };
                tempList.push(obj_temp);
              }
              if (vm.cpjsStatus == 0) {
                //新增
                vm.$emit("getLoading", true);
                var params = {
                  qyid: vm.qyid,
                  qyjj: vm.qyjsForm.qyjj,
                  reserve1: vm.qyjsForm.reserve1,
                  qycpjsVOList: tempList,
                  deleteFlag: "N",
                  src: vm.qyjsForm.src,
                  cjrid: vm.currentUser.userid,
                  cjrmc: vm.currentUser.username,
                  validateFlag: 'T'
                };
                vm.$axios.post("/qyjs/doInsertByVo", params).then(
                  function(res) {
                    if (res.data.result != null && res.data.result != "") {
                    
                      vm.$message({
                        message: "企业产品介绍暂存成功",
                        type: "success"
                      });
                      vm.$emit("getLoading", false);
                    // this.$emit("getActive",  5);
                    vm.editFlag = false;
                    this.findQyjsByQyid(this.qyid);
                    
                      vm.cpjsStatus = 1;
                      
                      vm.unsavedPicList = [];
                    } else {
                      vm.$message({
                        message: "企业产品介绍暂存失败",
                        type: "error"
                      });
                      vm.$emit("getLoading", false);
                    }
                  }.bind(vm),
                  function(error) {
                    vm.$emit("getLoading", false);
                    console.log(error);
                  }
                );
              } else {
                //修改
                vm.$emit("getLoading", true);
                var params = {
                  uuid: vm.qyjsForm.uuid,
                  qyid: vm.qyid,
                  src: vm.qyjsForm.src,
                  qyjj: vm.qyjsForm.qyjj,
                  reserve1: vm.qyjsForm.reserve1,
                  qycpjsVOList: tempList,
                  xgrid: vm.currentUser.userid,
                  xgrmc: vm.currentUser.username,
                  validateFlag: 'T'
                };
                vm.$axios.post("/qyjs/doUpdateQyCpByVO", params).then(
                  function(res) {
                    if (res.data.result != null && res.data.result != "") {
                    
                      vm.$message({
                        message: "企业产品介绍暂存成功",
                        type: "success"
                      });
                      vm.$emit("getLoading", false);
                    //  this.$emit("getActive",  5);
                      vm.editFlag = false;
                      this.findQyjsByQyid(this.qyid);

                      vm.cpjsStatus = 1;
                      vm.unsavedPicList = [];
                    } else {
                      vm.$message({
                        message: "企业产品介绍暂存失败",
                        type: "error"
                      });
                      vm.$emit("getLoading", false);
                    }
                  }.bind(vm),
                  function(error) {
                    vm.$emit("getLoading", false);
                    console.log(error);
                  }
                );
              }
            }
          } else {
            setTimeout(() => {
                var isError = document.getElementsByClassName("is-error");
                isError[0].querySelector('input,textarea').focus();
              }, 100);
            console.log("error submit!!");
            return false;
          }
        });
      }
      
    },
    //产品介绍上一步
    cancelCpjs: function() {
      this.$emit("getActive",  3);
      // let vm = this;
      // vm.delPicList = [];
      // if (vm.unsavedPicList.length > 0) {
      //   vm.$axios.post("/qycpjs/delPic", vm.unsavedPicList).then(
      //     function(res) {
      //       vm.unsavedPicList = [];
      //     }.bind(vm),
      //     function(error) {
      //       console.log(error);
      //     }
      //   );
      // }
    },

    editClick: function(){
      this.editFlag = true;
    },
    cancel: function(){
      this.findQyjsByQyid(this.qyid);
    },
    imgPreview: function(val) {
      this.previewImg = val;
      this.showPicVisible = true;
    },
 
  }
};
</script>

<style lang="scss">
#cpjsEdit {
  .mb5 {
    margin-bottom: 5px;
  }
  
  .el-card__body {
    padding: 10px 0px 10px 0px;
  }
  .el-message {
    z-index: 10005 !important;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }
  .el-dialog {
    width: 45%;
  }
  .el-button--small {
    padding: 9px 9px;
  }

  .card_title_font{
    line-height: 40px;
  }
  .clearfix{
    height: 40px;
  }
  #cpjsArea .el-form-item__error {
    padding-top: 1px;
  }
  #qycpArea .el-form-item__error {
    padding-top: 1px !important;
  }
  #cp_card .el-card__header {
    padding: 1px 15px;
  }
  #cplx_btn_group {
    margin-bottom: 10px;
  }
  #cplx_btn_group .el-button--small {
    margin-right: 10px;
  }
  #cplx_btn_group .el-button + .el-button {
    margin-left: 0;
  }
  #cplx_chb_group .el-checkbox {
    margin-right: 30px;
  }
  #cplx_chb_group .el-checkbox + .el-checkbox {
    margin-left: 0;
  }
  #cplx_btn_group .el-form-item__error {
    padding-top: 8px;
  }
  
}
  #cpjs .el-form-item__content {
    width: 100% !important;
  }
  #cpjsImg img {
    max-height: 100%;
    max-width: 100%;
  }
  #cpjs .el-form-item:nth-child(even) {
    margin-right: 0;
  }
</style>


// WEBPACK FOOTER //
// src/views/exhibition/prediction/exhprediction/exhpredictionEdit/Cpjs.vue